import * as React from 'react';

// The TTC Hub terms of business shown in the booking flow. Legal copy —
// content changes should come from the business, not engineering.
const BookingTerms = () => (
  <>
    <p>
      ABOUT US
      <br />
      <br />
      The Training and Compliance Hub Limited (“TTC”, “we” or “us”) is
      registered in England &amp; Wales with company number 10849230. Our
      registered address is Plesman House, 2a Cains Lane, Feltham, Middlesex,
      TW14 9RL.
      <br />
      <br />
      Course Booking Terms &amp; Conditions <br />
      <br />
      On receipt of a booking, we will send joining instructions and a VAT
      invoice which shall be payable within 7 working days. We accept most Debit
      and Credit Cards, BACS payments and Cheques (payable to The Training and
      Compliance Hub Limited). Certificates are only issued on receipt of full
      payment and we reserve the right to cancel, postpone or re-schedule any
      course. If you cancel or move to another course within 14 days of the
      course start date, a £35 + VAT fee will apply. If a delegate fails to turn
      up on the day of course, the full course fee shall be payable. Online
      courses are purchased directly on our website. A username and password
      will be automatically generated and an account created for the candidate
      to compete their course/s. Online courses are non-refundable once they
      have been purchased however, TTC reserves the right to offer a credit or
      voucher in special circumstances.
      <br />
      <br />
      INTELLECTUAL PROPERTY RIGHTS
      <br />
      <br />
      Unless otherwise explicitly stated, we are the owner of all intellectual
      property rights in our site and in the material published, including but
      not limited to any concepts, ideas, methods, procedures, processes,
      know-how, techniques, programs, publications, models, products, templates,
      technologies, software designs, art work, graphics and information on or
      described in our site. All such rights are reserved. Users are encouraged
      to distribute content (e.g. via link on a social network) provided that:{' '}
      <br /> <br />
      all copyright, trademark and similar notices are retained <br />
      the content does not imply that we are providing a testimonial or
      endorsement of an organisation, its products or services.
      <br />
      <br /> You must not modify, reproduce, publicly display, distribute or use
      without explicit written permission from the appropriate content or
      material provider (including third-party links).
      <br />
      <br />
      NO RELIANCE ON INFORMATION <br />
      <br />
      The content on our site is provided for general information only. It is
      not intended to amount to advice or serve as a substitute for any audit,
      advisory or other professional advice, consultation or service.
      <br />
      <br />
      OUR LIABILITY <br />
      <br />
      To the extent permitted by law, we exclude all conditions, warranties,
      representations or other terms which may apply to our site or any content
      on it, whether express or implied, included but not limited to that the
      site will be uninterrupted, without delay, error-free, omission-free, or
      free of viruses. TTC, its related partners, directors, agents or employees
      will not be liable to any user for any loss or damage arising under or in
      connection with but not limited to:
      <br />
      use of, or inability to use, our site; <br /> <br /> or use of, or
      reliance on, any content displayed on our site. <br /> <br />
      We have no liability to you for any loss of profit, data, sales or
      revenue, loss of business, business interruption or business opportunity
      or any indirect, incidental, special, exemplary, punitive, consequential
      or other loss or damage.
      <br />
      <br /> VIRUSES <br />
      <br />
      We do not guarantee that our site will be secure or free from bugs or
      viruses and will not be liable for any loss or damage caused by a virus
      either through our site or third-party link. You are responsible for
      configuring your information technology, computer programmes and platform
      in order to access our site. You should use your own virus protection
      software. You must not misuse our site by knowingly introducing viruses,
      trojans, worms, logic bombs or other material which is malicious or
      technologically harmful. You must not attack our site via a
      denial-of-service attack or a distributed denial-of service attack. By
      breaching this provision, you would commit a criminal offence under the
      Computer Misuse Act 1990.
      <br />
      <br />
      LINKING TO OUR SITE
      <br />
      <br />
      Where our site contains links to other sites and resources provided by
      third parties, these links are provided for your information and
      convenience only. We have no control over, and are not responsible for,
      the contents of those sites or resources. You must not establish any link
      without our explicit permission. We reserve the right to withdraw linking
      permission without notice.
    </p>
  </>
);

export default BookingTerms;
